import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaArrowLeft, FaImage } from "react-icons/fa";
import api from "../utils/api";
import "./ComplaintForm.css";

const RequestForm = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    category: "",
    title: "",
    description: "",
    address: ""
  });

  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const categories = [
    { value: "water", label: "Water Supply" },
    { value: "electricity", label: "Electricity" },
    { value: "drainage", label: "Drainage" },
    { value: "road", label: "Road" },
    { value: "medical", label: "Medical" },
    { value: "house_society", label: "House/Society" },
    { value: "other", label: "Other" }
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 2) {
      toast.error("Maximum 2 images allowed");
      return;
    }

    setImages(files);

    const previews = files.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.category || !formData.title || !formData.description) {
      toast.error("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("category", formData.category);
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("address", formData.address);

      images.forEach((img) => {
        formDataToSend.append("images", img);
      });

      await api.post("/service-requests", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      toast.success("Service request submitted successfully!");

      navigate("/dashboard");
    } catch (error) {
      console.error(error);

      toast.error(
        error.response?.data?.message || "Failed to submit request"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-page">
      <div className="form-container">

        <button className="back-btn" onClick={() => navigate("/dashboard")}>
          <FaArrowLeft /> Back to Dashboard
        </button>

        <h2>Service Request</h2>

        <form onSubmit={handleSubmit}>

          {/* Category */}

          <div className="form-group">
            <label>Category *</label>

            <select
              name="category"
              className="form-control"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="">Select Category</option>

              {categories.map((cat) => (
                <option key={cat.value} value={cat.value}>
                  {cat.label}
                </option>
              ))}
            </select>
          </div>

          {/* Title */}

          <div className="form-group">
            <label>Title *</label>

            <input
              type="text"
              name="title"
              className="form-control"
              placeholder="Brief title of your request"
              value={formData.title}
              onChange={handleChange}
              maxLength={200}
              required
            />
          </div>

          {/* Description */}

          <div className="form-group">
            <label>Description *</label>

            <textarea
              name="description"
              className="form-control"
              placeholder="Describe your service request in detail..."
              value={formData.description}
              onChange={handleChange}
              maxLength={1000}
              required
              style={{ minHeight: "150px" }}
            />
          </div>

          {/* Address */}

          <div className="form-group">
            <label>Location / Address</label>

            <input
              type="text"
              name="address"
              className="form-control"
              placeholder="Specific location or landmark"
              value={formData.address}
              onChange={handleChange}
            />
          </div>

          {/* Image Upload */}

          <div className="form-group">

            <label>Upload Images (Max 2)</label>

            <div className="file-upload">

              <input
                type="file"
                id="images"
                accept="image/*"
                multiple
                onChange={handleImageChange}
                hidden
              />

              <label htmlFor="images" className="file-upload-label">
                <FaImage /> Choose Images
              </label>

              <span className="file-count">
                {images.length > 0
                  ? `${images.length} image(s) selected`
                  : "No images selected"}
              </span>

            </div>

            {imagePreviews.length > 0 && (
              <div className="image-previews">

                {imagePreviews.map((preview, index) => (
                  <img
                    key={index}
                    src={preview}
                    alt={`preview-${index}`}
                  />
                ))}

              </div>
            )}

          </div>

          {/* Buttons */}

          <div className="form-actions">

            <button
              type="button"
              className="btn btn-back-dashboard"
              onClick={() => navigate("/dashboard")}
            >
              <FaArrowLeft /> Back to Dashboard
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate("/dashboard")}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit Request"}
            </button>

          </div>

        </form>
      </div>
    </div>
  );
};

export default RequestForm;